import React from 'react';
import { KM_CONFIG } from '../api/config.js';

export default function DemoBadge() {
  if (!KM_CONFIG.MOCK_MODE) return null;
  return (
    <span className="badge badge-warning" title="Nessuna chiamata reale al backend: dati e conversazione sono simulati">
      Modalità demo
    </span>
  );
}
